$(document).ready(function(){

	var index = new Index();
	var register = new Register();
	var login = new Login();
	var forgotPassword = new ForgotPassword();
	var resetPassword = new ResetPassword();
	var h = 0;

	$('.carrousel-container').slick({
		dots: true,
		infinite: true,
		speed: 300,
		slidesToShow: 1,
		arrows:false
	});

	$('.carrousel-container').each(function(){
		$(this).find('.preco').each(function(){
			if ($(this).outerHeight() > h) {
		    h = $(this).outerHeight();
			}
		});
		$(this).find('.preco').outerHeight(h);
	});

	$('.select-plan').select2({
		allowClear: true,
		width: 'resolve'
	});

	$('.parent-equalizr').each(function () {
		$(this).find('[data-component="individual-price"]').each(function () {
			if ($(this).outerHeight() > h) {
		    h = $(this).outerHeight();
			}
		});
		$(this).find('[data-component="individual-price"]').outerHeight(h);
	});

	$(".modal-open").on('click',function(){
		var modal = $(this).data('modal');
		console.log($(modal));
		$(modal).show();
		$(modal).css({"opacity":"100","pointer-events":"all"});
		$('.chatDialog iframe').attr('src', URL_CHAT);
		$("body").css("overflow", "hidden");
	});

	$(".modalDialog").on('click',function(){
		var frameId = this.dataset.frame;
		var frameUrl = this.dataset.url;
	   $(".modalDialog").css({"opacity":"0","pointer-events":"none"});
	   $(".chatDialog").css({"opacity":"0","pointer-events":"none"});
	   $("body").css("overflow", "auto");
	});

	$('.modal-see-more').css('display', 'none');

	$(document).keyup(function(e) {
		 if (e.keyCode == 27) {
			$(".modalDialog").css({"opacity":"0","pointer-events":"none"});
			$(".chatDialog").css({"opacity":"0","pointer-events":"none"});
			$("body").css("overflow", "auto");
		}
	});

	$(".closeModal").on('click',function(){
		var frameId = this.dataset.frame;
		var frameUrl = this.dataset.url;
	   $(".modalDialog").css({"opacity":"0","pointer-events":"none"});
	   $("body").css("overflow", "auto");
	});
	$(".closeChatDialog").on('click',function(){
		var frameId = this.dataset.frame;
		var frameUrl = this.dataset.url;
	   $(".chatDialog").css({"opacity":"0","pointer-events":"none"});
	   $("body").css("overflow", "auto");
	});

	$(".contact_submit_btn").on('click',function(){
		if($("input[name=your-name]").val()==''){
			alert('O Nome não pode estar em branco.');
			$("input[name=your-name]").focus();
		} else if($("input[name=your-email]").val()==''){
			alert('O Email não pode estar em branco.');
			$("input[name=your-email]").focus();
		} else if($("input[name=your-subject]").val()==''){
			alert('O Tipo de Contato não pode estar em branco.');
			$("input[name=your-subject]").focus();
		} else if($.trim($("textarea[name=your-message]").val()).length < 5){
			alert('A Mensagem não pode estar em branco.');
			$("textarea[name=your-message]").focus();
		} else {
			$("#contact-form").submit();
		}
	});

	$('nav').on('click',function(){
		$('nav').removeClass('show');
	})


    $(".plans-table tr:odd").css("background-color", "#ddd");

	$('.plano-anual').fadeIn();
	$('.plano-mensal').hide();

	var is_anual_selected = false;



	$('.plano-mensal-mobile').on('click',function(){
		ativa_planos_mensais();
	});

	$('.plano-anual-mobile').on('click',function(){
		ativa_planos_anuais();
	});

	$('.slider-checkbox').on('click',function(){
		if(is_anual_selected==true){
			ativa_planos_mensais();
		} else {
			ativa_planos_anuais();
		}
	});


	function ativa_planos_mensais(){
		is_anual_selected = false;
		console.log('bufferMensal');
		$('.plano-mensal-mobile').removeClass('faded-plans');
		$('.plano-anual-mobile').addClass('faded-plans');
		$('.slider-checkbox-animated').removeClass('slider-checkbox-animated-right').addClass('slider-checkbox-animated-left');
		$('.plano-mensal').fadeIn();
		$('.plano-anual').fadeOut();
		avoid_callback = 0;
	}
	function ativa_planos_anuais(){
		is_anual_selected = true;
		console.log('bufferAnual');
		$('.plano-mensal-mobile').addClass('faded-plans');
		$('.plano-anual-mobile').removeClass('faded-plans');
		$('.slider-checkbox-animated').removeClass('slider-checkbox-animated-left').addClass('slider-checkbox-animated-right');
		$('.plano-mensal').fadeOut();
		$('.plano-anual').fadeIn();
		avoid_callback = 0;
	}

	$('.slider-checkbox').click();

});

	function CheckPassStrength()
	{
		var password = $('[type="password"]').val();
		var specialCharacters = "!@#$%^&*_~?";
		var passwordScore = 0;

		for(var i=0; i <  password.length; i++)
		{
			if(specialCharacters.indexOf(password.charAt(i)) > -1)
			{
				passwordScore += 20;
			}
		}
		if(/[a-z]/.test(password))
		{
			passwordScore += 20;
		}

		if(/[A-Z]/.test(password))
		{
			passwordScore += 20;
		}

		if(/[\d]/.test(password))
		{
			passwordScore += 20;
		}

		if(password.length >= 8)
		{
			passwordScore += 20;
		}

		if(passwordScore >= 100)
		{
			$('.pass-very-weak').css('display','none');
			$('.pass-medium').css('display','none');
			$('.pass-weak').css('display','none');
			TweenMax.fromTo($('.pass-strong'), 0.2, {css:{alpha:0,display:'block'}}, {css:{alpha:1}, ease:Power0.easeNone});
			TweenMax.to($('.pass-str span'), 1, { backgroundColor: '#00b5ad', border: '1px solid #00b5ad', ease:Power0.easeNone});
		}
		else if(passwordScore >= 80)
		{
			$('.pass-very-weak').css('display','none');
			$('.pass-weak').css('display','none');
			$('.pass-strong').css('display','none');
			TweenMax.fromTo($('.pass-medium'), 0.2, {css:{alpha:0,display:'block'}}, {css:{alpha:1}, ease:Power0.easeNone});

			TweenMax.to($('.pass-str span'), 1, { backgroundColor: '#fff', border: '1px solid #666', ease:Power0.easeNone});
			TweenMax.to($('.pass-str span:first-child'), 1, { backgroundColor: '#ffd000', border: '1px solid #ffd000', ease:Power0.easeNone});
			TweenMax.to($('.pass-str span:nth-child(2)'), 1, { backgroundColor: '#ffd000', border: '1px solid #ffd000', ease:Power0.easeNone});
			TweenMax.to($('.pass-str span:nth-child(3)'), 1, { backgroundColor: '#ffd000', border: '1px solid #ffd000', ease:Power0.easeNone});
		}
		else if(passwordScore >= 60)
		{
			$('.pass-very-weak').css('display','none');
			$('.pass-medium').css('display','none');
			$('.pass-strong').css('display','none');
			TweenMax.fromTo($('.pass-weak'), 0.2, {css:{alpha:0,display:'block'}}, {css:{alpha:1}, ease:Power0.easeNone});
			TweenMax.to($('.pass-str span'), 1, { backgroundColor: '#fff', border: '1px solid #666', ease:Power0.easeNone});
			TweenMax.to($('.pass-str span:first-child'), 1, { backgroundColor: '#FF5733', border: '1px solid #FF5733', ease:Power0.easeNone});
			TweenMax.to($('.pass-str span:nth-child(2)'), 1, { backgroundColor: '#FF5733', border: '1px solid #FF5733', ease:Power0.easeNone});
		}
		else
		{
			$('.pass-weak').css('display','none');
			$('.pass-medium').css('display','none');
			$('.pass-strong').css('display','none');
			TweenMax.fromTo($('.pass-very-weak'), 0.2, {css:{alpha:0,display:'block'}}, {css:{alpha:1}, ease:Power0.easeNone});
			TweenMax.to($('.pass-str span'), 1, { backgroundColor: '#fff', border: '1px solid #666', ease:Power0.easeNone});
			TweenMax.to($('.pass-str span:first-child'), 1, { backgroundColor: '#FF3333', border: '1px solid #FF3333', ease:Power0.easeNone});
		}

	};
